<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      Configuration
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

          <text-input v-model="form.email_subject" :error="form.errors.email_subject" class="pr-6 pb-8 w-full" label="Email Subject" />
          <rich-text v-model="form.email_body" :error="form.errors.email_body" rows="8" class="pr-6 pb-8 w-full" label="Email Body" />

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <button v-if="!form.isDirty && form.email_subject && form.email_body" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="sendTestEmail">Send me a test email</button>
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Save Configuration</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextArea from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import RichText from '@/Shared/RichText'
import 'vue2-datepicker/index.css';

export default {
  metaInfo: { title: 'Configuration' },
  components: {
    LoadingButton,
    TextInput,
    TextArea,
    RichText
  },
  layout: Layout,
  props: {
    configuration: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        email_subject: this.configuration ? this.configuration.email_subject : null,
        email_body: this.configuration ? this.configuration.email_body : null,
      }),

    }
  },
  methods: {
    store() {
      this.form.put(this.route('config.update'))
    },
    sendTestEmail(){
      this.$inertia.post(this.route('config.test'), {})
    }
  },
}
</script>
